<div>


    <!-- Main Content -->
    <div class="main-content">
        <header class="top-header">
            <h3>Add Organization</h3>
        </header>

        <form class="form" [formGroup]="organizationForm" (ngSubmit)="onSubmit()">
            <div class="form-row">
                <div class="form-group">
                    <label>Name <small>*</small></label>
                    <input type="text" placeholder="Organization Name" formControlName="name">
                    <div class="error"
                        *ngIf="organizationForm.get('name')?.invalid && organizationForm.get('name')?.touched">
                        <small *ngIf="organizationForm.get('name')?.errors?.['required']">Name is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Flat/Building Name <small>*</small></label>
                    <input id="flatBuildingName" formControlName="flatBuildingName"
                        placeholder="Flat / Building Name" />
                    <div class="error"
                        *ngIf="organizationForm.get('flatBuildingName')?.invalid && organizationForm.get('flatBuildingName')?.touched">
                        <small *ngIf="organizationForm.get('flatBuildingName')?.errors?.['required']">Flat/Building Name
                            is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label>Locality <small>*</small></label>
                    <input type="text" placeholder="Locality" formControlName="locality">
                    <div class="error"
                        *ngIf="organizationForm.get('locality')?.invalid && organizationForm.get('locality')?.touched">
                        <small *ngIf="organizationForm.get('locality')?.errors?.['required']">Locality is
                            required.</small>
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div class="form-row"> -->
                <div class="form-group">
                    <label for="pincode">Pincode <small>*</small></label>
                    <input type="text" id="pincode" placeholder="PIN Code" formControlName="pincode"
                        (input)="onPincodeChange()">
                    <div class="error"
                        *ngIf="organizationForm.get('pincode')?.invalid && organizationForm.get('pincode')?.touched">
                        <small *ngIf="organizationForm.get('pincode')?.errors?.['required']">Pincode is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="city">City <small>*</small></label>
                    <input id="city" formControlName="city" placeholder="City">
                    <!-- <option *ngFor="let option of role | keyvalue" [value]="option.value">{{ option.value }}</option> -->
                    <div class="error"
                        *ngIf="organizationForm.get('city')?.invalid && organizationForm.get('city')?.touched">
                        <small *ngIf="organizationForm.get('city')?.errors?.['required']">City is required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="state">State <small>*</small></label>
                    <input id="state" formControlName="state" placeholder="State">
                    <div class="error"
                        *ngIf="organizationForm.get('state')?.invalid && organizationForm.get('state')?.touched">
                        <small *ngIf="organizationForm.get('state')?.errors?.['required']">State is required.</small>
                    </div>
                </div>
                <!-- </div> -->
                <!-- <div class="form-row"> -->
                <div class="form-group">
                    <label for="landmark">Landmark</label>
                    <input id="landmark" formControlName="landmark" placeholder="Landmark">
                    <div class="error"
                        *ngIf="organizationForm.get('landmark')?.invalid && organizationForm.get('landmark')?.touched">
                        <small *ngIf="organizationForm.get('landmark')?.errors?.['required']">Landmark is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="addressType">Address Type <small>*</small></label>
                    <select formControlName="addressType" id="addressType" placeholder="Address Type">
                        <option value="" disabled selected>Select Address Type</option>
                        <option *ngFor="let option of addressTypes" [value]="option">{{ option }}</option>
                    </select>
                    <div class="error"
                        *ngIf="organizationForm.get('addressType')?.invalid && organizationForm.get('addressType')?.touched">
                        <small *ngIf="organizationForm.get('addressType')?.errors?.['required']">Address Type is
                            required.</small>
                    </div>
                </div>
                <div class="form-group">
                    <label for="timezone">Timezone <small>*</small></label>
                    <select formControlName="timezone" id="timezone">
                         <option *ngFor="let tz of timezones" [value]="tz">
                            {{ tz }}
                        </option>
                    </select>
                    <div class="error"
                        *ngIf="organizationForm.get('timezone')?.invalid && organizationForm.get('timezone')?.touched">
                        <small *ngIf="organizationForm.get('timezone')?.errors?.['required']">Timezone is
                            required.</small>
                    </div>
                </div>
                <div class="form-group" *ngIf="isPlatformSuperuser">
                    <label for="customer_source">Customer Source</label>
                    <select formControlName="customer_source" id="customer_source">
                        <option value="">Select Customer Source</option>
                        <option *ngFor="let option of customerSources" [value]="option[0]">{{ option[1] }}</option>
                    </select>
                </div>
                <app-sales-installation-partner-select
                        *ngIf="isPlatformSuperuser && showSourcePartnerField"
                    mode="form"
                    label="Source Partner"
                    placeholder="Select Source Partner"
                    [value]="organizationForm.get('source_sales_installation_partner')?.value"
                    (valueChange)="setSourcePartner($event)">
                </app-sales-installation-partner-select>
                <div class="form-group" *ngIf="isPlatformSuperuser">
                    <label for="installation_by">Installation By</label>
                    <select formControlName="installation_by" id="installation_by">
                        <option value="">Select Installation Responsibility</option>
                        <option *ngFor="let option of installationOptions" [value]="option[0]">{{ option[1] }}</option>
                    </select>
                </div>
                <app-sales-installation-partner-select
                        *ngIf="isPlatformSuperuser && showInstallationPartnerField"
                    mode="form"
                    label="Installation Partner"
                    placeholder="Select Installation Partner"
                    [value]="organizationForm.get('installation_sales_installation_partner')?.value"
                    (valueChange)="setInstallationPartner($event)">
                </app-sales-installation-partner-select>
                <div class="form-group form-group-checkbox">
                    <label for="isDefault">disabled</label>
                    <div class="check">
                        <input type="checkbox" id="isDefault" formControlName="isDefault" />
                        <span>Set As Default Address</span>
                    </div>
                </div>
                <div class="form-group form-group-checkbox">
                     <label for="isDefault">disabled</label>
                    <div class="check">
                        <input type="checkbox" id="isDemoAccount" formControlName="is_demo_account" />
                        Demo Account
                    </div>
                </div>
                <div class="form-group" *ngIf="organizationForm.get('is_demo_account')?.value">
                    <label for="demo_duration_days">Demo Duration</label>
                    <select formControlName="demo_duration_days" id="demo_duration_days">
                        <option *ngFor="let days of demoDurations" [value]="days">{{ days }} days</option>
                    </select>
                </div>

                <!-- <div class="form-group">
                <label for="isDefault">Mark As Default Address</label>
                <div class="check">
                    <input type="checkbox" id="isDefault" formControlName="isDefault"/>
                    Set As Default Address
                </div>
            </div> -->
            </div>
            <div class="button-row">
                <button class="btn-save" type="submit">
                    <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
                    ADD
                </button>
                <button class="btn-cancel" type="button" (click)="onCancel()">
                    <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
                    Cancel
                </button>
            </div>
        </form>
    </div>
</div>
